// @flow

import { useState, useEffect, useCallback } from 'react';
import { TweenMax, Power2 } from 'gsap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import type { RootState } from '../../../store/types';
import { SUBSTEP_UPDATE } from '../../../store/actions';

export const useSubSteps = (defaultSubState: number = 0) => {
  const { substep } = useParams();
  const [currentSubStep, setSubStep] = useState<number>(0);
  const dispatch = useDispatch();
  const common = useSelector((state: RootState) => state.common);

  const changeSubStep = useCallback(
    (subStep: number) => {
      dispatch({
        type: SUBSTEP_UPDATE,
        payload: subStep,
      });
      TweenMax.to(window, 0.3, {
        scrollTo: { y: 'header', autoKill: true },
        ease: Power2.easeInOut,
      });
    },
    [dispatch]
  );

  const showSubStep = useCallback((id: number, fromRight: boolean = true) => {
    TweenMax.to('.step', 0.3, {
      x: fromRight ? -100 : 100,
      alpha: 0,
      ease: Power2.easeOut,
      onComplete: () => {
        setSubStep(id);
        TweenMax.fromTo(
          '.step',
          0.3,
          { x: fromRight ? 100 : -100, alpha: 0 },
          { x: 0, alpha: 1, ease: Power2.easeOut }
        );
      },
    });
  }, []);

  useEffect(() => {
    // If url parameter :substep, change subStep
    if (substep) {
      changeSubStep(Number(substep) - 1);
    } else {
      // Else reset subStep to zero
      dispatch({
        type: SUBSTEP_UPDATE,
        payload: defaultSubState,
      });
    }
  }, [changeSubStep, dispatch, substep]);

  useEffect(() => {
    if (currentSubStep !== common.subStep) {
      showSubStep(common.subStep, currentSubStep < common.subStep);
    }
  }, [common.subStep, currentSubStep, showSubStep]);

  return [currentSubStep, changeSubStep];
};
